import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  Modal,
} from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';
import { DatetimePicker } from '../../../commons/controls';
import Services from '../services';
import SzemelyContent from './SzemelyContent';
import Loader from '../../../commons/loader';
import NetworkEmptyState from '../../../commons/networkemptystate';
import { ProgressButton } from '../../../commons/ProgressButton';
import PartnerContent from './PartnerContent';
import PartnerForm from './PartnerForm';
import PartnerHozzajarulasForm from './PartnerHozzajarulasForm';
import Lib from '../../../commons/lib';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import SelectField from '../../../components/Form/SelectField';
import TimeFormatter from '../../../commons/TimeFormatter';

const ROW_STYLE = { marginBottom: '15px' };
let selected = false;
const VasarloiKartyaForm = (props) => {
  const {
    id,
    globals,
    modositas,
    aktivalas,
    activateAzonosito,
    toggleFormModal,
    loadVasarloiKartyaPrint,
    listVasarloiKartyaForm
  } = props;

  const [formKartyaTipus, setFormKartyaTipus] = useState(null);
  const [formAzonosito, setFormAzonosito] = useState(null);
  const [formMennyiseg, setFormMennyiseg] = useState('');
  const [formCsoport, setFormCsoport] = useState('');
  const [formHelyszin, setFormHelyszin] = useState(null);
  const [formVege, setFormVege] = useState(null);
  const [formKezdete, setFormKezdete] = useState(null);
  const [formErvenytelenites, setFormErvenytelenites] = useState(null);
  const [formFizmod, setFormFizmod] = useState(null);
  const [formCsere, setFormCsere] = useState(false);
  const [formCserelt, setFormCserelt] = useState(null);
  const [formFizetesimodkotelezo, setFormFizetesimodkotelezo] = useState(false);
  const [formMegjegyzes, setFormMegjegyzes] = useState('');

  const [ids, setIds] = useState([id]);
  const [loadingSaveButton, toggleLoadingSaveButton] = useState(false);
  const [formStatus, setFormStatus] = useState('DATA'); // ['LOAD', 'DATA', 'NETW']
  const [selectedPartner, setSelectedPartner] = useState([]);
  const [selectedSzemely, setSelectedSzemely] = useState([]);
  
  const [dataPartner, setDataPartner] = useState([]);
  const [dataSzemely, setDataSzemely] = useState([]);

  const [showTulajdonos, toggleShowTulajdonos] = useState(false);
  const [showCsere, toggleShowCsere] = useState(formCsere);
  const [showTulajdonosForm, toggleShowTulajdonosForm] = useState(false);
  const [showTulajdonosGdprForm, toggleShowTulajdonosGdprForm] = useState(false);
  const [partnerResponse, setPartnerResponse] = useState(null);
  const [telefonTipusOptions, setTelefonTipusOptions] = useState([]);
  const [orszagHivoOptions, setOrszagHivoOptions] = useState([]);

  useEffect(() => {
    if(modositas || aktivalas){
      getVasarloiKartya(id);
    }
  }, []);

  useEffect(() => {
    if(showTulajdonosForm){
      loadTelefonOptions();
    }
  }, [showTulajdonosForm]);

  useEffect(() => {
    if(formKartyaTipus && !showTulajdonosForm){
      toggleShowTulajdonosGdprForm(true);
      if(!isTulajdonosPartner()){
        loadSzemelyData();
      }
    }
  }, [showTulajdonosForm]);

  useEffect(() => {
    if(showTulajdonos){
      if(!isTulajdonosPartner()){
        loadSzemelyData();
      }
    }
  }, [showTulajdonos]);

  useEffect(() => {
    if(formKartyaTipus && !showTulajdonosGdprForm){
      if(!isTulajdonosPartner()){
        loadSzemelyData();
      }
    }
  }, [showTulajdonosGdprForm]);

  useEffect(() => {
    setFormCsere(showCsere);
    if(!showCsere){
      setFormCserelt(null);
    }else{
      setFormMennyiseg('1');
    }
  }, [showCsere]);

  useEffect(() => {
    const req = formKartyaTipus && formKartyaTipus.csoport && formKartyaTipus.csoport.name.includes('KOTELEZO');
    toggleShowTulajdonos(req || (hasPartner()) || (hasSzemely()));
  }, [formKartyaTipus]);

  const handleToggleShowTulajdonosForm = (value) => {
    if (!value)
      loadPartnerData(formKartyaTipus && formKartyaTipus.partnercsoportId);
    toggleShowTulajdonosForm(value);
  }

  const loadHelyszinOptions = (input, callback) => {
    Services.listHelyszinSelect((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !formHelyszin && options.length === 1) {
          setFormHelyszin(options[0]);
        }
      }
    });
  }

  const loadFizmodOptions = (input, callback) => {
    Services.listFizmodAktiv((err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( f => f.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadTelefonOptions = () => {
    Services.listTelefonEnum((err, res) => {
          if (!err) {
            let options = res[0][1].map(e => <option key={e.name} value={e.name}>{e.caption}</option>);
            setTelefonTipusOptions(options);
            setOrszagHivoOptions(res[0][0]);
          }
        });
  }

  const loadKartyaTipusOptions = (input, callback) => {
    Services.listKartyaTipusSelect(false, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);

        if(!input && !formKartyaTipus && options.length === 1) {
          setFormKartyaTipus(options[0]);
          clearForm(options[0]);
          setFormFizetesimodkotelezo(options[0] && options[0].fizetesimodkotelezo);
          if (isTulajdonosPartner(options[0])) {
            loadPartnerData(options[0] && options[0].partnercsoportId);
          } else {
            loadSzemelyData();
          }
        }
      }
    });
  }

  const loadVasarloiKartyaOptions = (input, callback) => {
    let filters = {};
    filters['kartyaTipusId'] = formKartyaTipus ? formKartyaTipus.id : null;
    filters['aktiv'] = 'INAKTIV';
    filters['listainaktiv'] = true;
    Services.listVasarloiKartya(filters, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.azonosito.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadVasarloiKartyaCsereOptions = (input, callback) => {
    let filters = {};
    filters['kartyaTipusId'] = formKartyaTipus ? formKartyaTipus.id : null;
    filters['aktiv'] = 'AKTIV';
    Services.listVasarloiKartya(filters, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => k.azonosito.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const loadPartnerData = (partnerCsoportId) => {
    Services.listPartner(partnerCsoportId, selectedPartner && selectedPartner[0] && selectedPartner[0].id, (err, res) => {
      if (!err) {
        setDataPartner(res[0].map(p => {
          return {...p, ...{ telefonszamok: p.telefon.join(", ") }};
        }));
      }
    });
  }

  const loadSzemelyData = () => {
    Services.listDolgozo(null, (err, res) => {
      if (!err) {
        setDataSzemely(res[0].list);
      }
    });
  }

  const onRowSelectPartner = (partner, isSelected, e) => {
    if(isSelected && partner){
      setSelectedPartner([partner]);
    }else{
      setSelectedPartner([]);
    }
  }

  const onRowSelectSzemely = (szemely, isSelected, e) => {
    if(isSelected && szemely){
      setSelectedSzemely([szemely]);
    }else{
      setSelectedSzemely([]);
    }
  }

  const handleUpdateClick = (kartyaAzon) => {
    if(kartyaAzon){
      let kezdete = new Date();
      if(kartyaAzon.ervenytelenites && kartyaAzon.kartyaTipus.ervenyesitheto && kartyaAzon.aktivalva){
        const DAYS = 24 * 60 * 60 * 1000;
        kezdete = new Date(new Date(kartyaAzon.ervenytelenites).getTime() + (1 * DAYS));
      }
      setFormKezdete(kezdete);
      setIds(kartyaAzon.map(a => a.id));
    }
    activateAzonosito(kartyaAzon);
  }

  const setCurrentTime = (e) => {
    let now = new Date();
    if (e && selected)
      e = new Date(e).setHours(now.getHours(), now.getMinutes(), now.getSeconds());
    return e;
  }

  // Azért kell a paraméterből is átadni a kártyatípust, mert amikor az onChange megfut arra még nem kerül betöltésre a formKartyaTipus, null/előző érték lesz
  const handleSetFormKezdete = (e, kartyaTipusObj) => {
    e = setCurrentTime(e);
    setFormKezdete(e);
    let kartyaTipus = kartyaTipusObj || formKartyaTipus;
    let vege = null;
    // Nem korlátozott és nem kézi típusú a vége
    if (isDisabledVege(kartyaTipus) && isVisibleVege(kartyaTipus)) {
      const DAYS = 24 * 60 * 60 * 1000;
      if (e) {
        vege = new Date(new Date(e).getTime() + (kartyaTipus.vegetolNap ? (kartyaTipus.vegetolNap * DAYS) : 0));
        if (isVegeTipusNapVege(kartyaTipus))
         vege.setHours(23, 59, 59);
      }
      setFormVege(vege);
    }
    selected = false;
  }

  const handleSetFormVege = (e) => {
    if (!isVegeTipusNapVege()) {
      e = setCurrentTime(e);
      setFormVege(e);
    } else {
      let date = new Date(e);
      date.setHours(23, 59, 59);
      setFormVege(date);
    }
    selected = false;
  }

  const handleSetFormErvenytelenites = (e, v) => {
    if (selected) {
      selected = false;
      setFormErvenytelenites(v == '' ? null : moment(e).endOf('day'));
    } else {
      setFormErvenytelenites(e);
    }
  }

  const clearForm = (kartyaTipus) => {
    setFormAzonosito(null);
    setFormMennyiseg('');
    setFormHelyszin(null);
    setFormFizmod(null);
    setFormKezdete(new Date());
    setFormVege(setVegeDatum(kartyaTipus));
    setFormErvenytelenites(null);
    setSelectedPartner([]);
    setSelectedSzemely([]);
    setFormCsere(false);
    setFormCserelt(null);
  }

  const setVegeDatum = (kartyaTipus) => {
    const kezdete = new Date();
    let vege = null;
    if(kartyaTipus && kartyaTipus.ervenyessegVege && kartyaTipus.ervenyessegVege.name == 'KIALLITASTOL'){
      const DAYS = 24 * 60 * 60 * 1000;
      vege = new Date(kezdete.getTime() + (kartyaTipus.vegetolNap ? (kartyaTipus.vegetolNap * DAYS) : 0));
      if (isVegeTipusNapVege())
        vege.setHours(23, 59, 59);
    }
    return vege;
  }

  const getVasarloiKartya = (id) => {
    Services.getVasarloiKartya(id, (err, res) => {
      if (!err) {
        const csoport = res[0].kartyaTipus && res[0].kartyaTipus.csoport;
        const aktivTulaj = res[0].aktiv;
        const partnerExists = aktivTulaj && !!aktivTulaj.partnerTortenetId;
        const szemelyExists = aktivTulaj && !!aktivTulaj.szemelyId;

        const selectedPartner = csoport.name.includes('PARTNER') && partnerExists ?
            [{
              id: aktivTulaj.partnerTortenetId,
              nev: aktivTulaj.tulajdonos && aktivTulaj.tulajdonos.nev,
              telefonszam: aktivTulaj.tulajdonos && aktivTulaj.tulajdonos.telefonszam,
              email: aktivTulaj.tulajdonos && aktivTulaj.tulajdonos.email,
              szuletesnap: aktivTulaj.tulajdonos && aktivTulaj.tulajdonos.szuletesnap
            }] : [];

        const selectedSzemely = csoport.name.includes('SZEMELY') && szemelyExists ?
        [{
          id: aktivTulaj.szemelyId,
          nev: aktivTulaj.tulajdonos && aktivTulaj.tulajdonos.nev,
        }] : [];

        setFormStatus('DATA');
        setFormKartyaTipus(res[0].kartyaTipus);
        setFormFizetesimodkotelezo(res[0].kartyaTipus.fizetesimodkotelezo);
        if (isTulajdonosPartner(res[0].kartyaTipus))
          loadPartnerData(res[0].kartyaTipus && res[0].kartyaTipus.partnercsoportId);
        setFormAzonosito({id: res[0].id, azonosito: res[0].azonosito});
        setFormCsoport(res[0].csoport);
        setFormHelyszin(aktivTulaj ? aktivTulaj.helyszin : null);
        setFormFizmod(aktivTulaj ? aktivTulaj.fizmod : null);
        setSelectedPartner(selectedPartner);
        setSelectedSzemely(selectedSzemely);
        setFormKezdete(aktivTulaj ? aktivTulaj.kezdete : null);
        setFormVege(aktivTulaj ? aktivTulaj.vege : null);
        setFormErvenytelenites(res[0].ervenytelenites);
        setFormCsere(res[0].csere);
        setFormCserelt(res[0].cserelt);
        setFormMegjegyzes(aktivTulaj ? aktivTulaj.megjegyzes : null);
        toggleShowTulajdonos(false);
      } else {
        setFormStatus('NETW');
      }
    });
  }

  const saveVasarloiKartya = () => {
    if(aktivalas){
      let submitObj = {};
        let input = {};

        submitObj.ids = ids;
        input.kartyaTipusId = formKartyaTipus && formKartyaTipus.id;
        input.partnertortenetId = (selectedPartner && selectedPartner.length > 0) ? selectedPartner[0].id : null;
        input.szemelyId = (selectedSzemely && selectedSzemely.length > 0) ? selectedSzemely[0].id : null;
        input.helyszinId = formHelyszin && formHelyszin.id;
        input.fizmodId = formFizmod && formFizmod.id;
        input.azonosito = formAzonosito && formAzonosito.azonosito;
        input.kezdete = formKezdete ? TimeFormatter.formatIso(formKezdete) : null;
        input.vege = formVege ? TimeFormatter.formatIso(formVege) : null;
        input.ervenytelenites = formErvenytelenites ? TimeFormatter.formatIso(formErvenytelenites) : null;
        input.csere = formCsere;
        input.csereltId = formCserelt && formCserelt.id;
        input.megjegyzes = formMegjegyzes;
        submitObj["input"] = input;

        toggleLoadingSaveButton(true);
        Services.activateVasarloiKartya(submitObj, (err) => {
          if (!err) {
            globals.addSuccess('Kiválaszott azonosítók aktiválva!');
            listVasarloiKartyaForm(formKartyaTipus);
            toggleFormModal();
          }
          toggleLoadingSaveButton(false);
        });

    }else{
      if (!modositas) {
        let submitObj = {};

        submitObj.helyszinId = formHelyszin && formHelyszin.id;
        submitObj.fizmodId = formFizmod && formFizmod.id;
        submitObj.mennyiseg = formMennyiseg;
        submitObj.csoport = formCsoport;
        submitObj.kartyaTipusId = formKartyaTipus && formKartyaTipus.id;
        submitObj.partnertortenetId = (selectedPartner && selectedPartner.length > 0) ? selectedPartner[0].id : null;
        submitObj.szemelyId = (selectedSzemely && selectedSzemely.length > 0) ? selectedSzemely[0].id : null;
        submitObj.kezdete = formKezdete ? TimeFormatter.formatIso(formKezdete) : null;
        submitObj.vege = formVege ? TimeFormatter.formatIso(formVege) : null;
        submitObj.ervenytelenites = formErvenytelenites ? TimeFormatter.formatIso(formErvenytelenites) : null;
        submitObj.csere = formCsere;
        submitObj.csereltId = formCserelt ? formCserelt.id : null;
        submitObj.megjegyzes = formMegjegyzes;

        if(formMennyiseg && formMennyiseg > 1){
          toggleLoadingSaveButton(true);
          Services.addVasarloiKartyaGroup(submitObj, (err, res) => {
            if (!err) {
              globals.addSuccess('Vásárlói kártyák felvéve!');
              listVasarloiKartyaForm(formKartyaTipus);
              loadVasarloiKartyaPrint(res[0]);
              setSelectedPartner([]);
              setSelectedSzemely([]);
              toggleFormModal();
            }
            toggleLoadingSaveButton(false);
          });
        }else{
          toggleLoadingSaveButton(true);
          Services.addVasarloiKartya(submitObj, (err, res) => {
            if (!err) {
              globals.addSuccess('Vásárlói kártya felvéve!');
              listVasarloiKartyaForm(formKartyaTipus);
              loadVasarloiKartyaPrint([res[0]]);
              setSelectedPartner([]);
              setSelectedSzemely([]);
              toggleFormModal();
            }
            toggleLoadingSaveButton(false);
          });
        }
      } else {
        let submitObj = {};

        submitObj.id = id;
        submitObj.helyszinId = formHelyszin && formHelyszin.id;
        submitObj.fizmodId = formFizmod && formFizmod.id;
        submitObj.kartyaTipusId = formKartyaTipus && formKartyaTipus.id;
        submitObj.partnertortenetId = (selectedPartner && selectedPartner.length > 0) ? selectedPartner[0].id : null;
        submitObj.szemelyId = (selectedSzemely && selectedSzemely.length > 0) ? selectedSzemely[0].id : null;
        submitObj.kezdete = formKezdete ? TimeFormatter.formatIso(formKezdete) : null;
        submitObj.vege = formVege ? TimeFormatter.formatIso(formVege) : null;
        submitObj.ervenytelenites = formErvenytelenites ? TimeFormatter.formatIso(formErvenytelenites) : null;
        submitObj.csere = formCsere;
        submitObj.csereltId = formCserelt ? formCserelt.id : null;
        submitObj.megjegyzes = formMegjegyzes;

        toggleLoadingSaveButton(true);
        Services.editVasarloiKartya(submitObj, (err) => {
          if (!err) {
            globals.addSuccess('Vásárlói kártya módosítva!');
            toggleFormModal();
            listVasarloiKartyaForm(formKartyaTipus);
          } 
          toggleLoadingSaveButton(false);
        });
      }
    }
  }

  const isTulajdonosPartner = (kartyaTipus) => {
    let kt = kartyaTipus || formKartyaTipus;
    return kt && kt.csoport && kt.csoport.name.includes('PARTNER');
  }

  const isVisibleAnyTulajdonos = () => {
    return formKartyaTipus && formKartyaTipus.csoport && formKartyaTipus.csoport.name !== 'NEM_JELENIK';
  }

  const isDisabledKezdete = () => {
    return formKartyaTipus && formKartyaTipus.ervenyessegKezdete && formKartyaTipus.ervenyessegKezdete.name !== 'KEZI';
  }

  // Azért kell a paraméterből is átadni a kártyatípust, mert amikor az onChange megfut arra még nem kerül betöltésre a formKartyaTipus, null/előző érték lesz
  const isVisibleVege = (kartyaTipusObj) => {
    let kartyaTipus = kartyaTipusObj || formKartyaTipus;
    return kartyaTipus && kartyaTipus.ervenyessegVege && kartyaTipus.ervenyessegVege.name !== 'KORLATLAN';
  }

  // Azért kell a paraméterből is átadni a kártyatípust, mert amikor az onChange megfut arra még nem kerül betöltésre a formKartyaTipus, null/előző érték lesz
  const isDisabledVege = (kartyaTipusObj) => {
    let kartyaTipus = kartyaTipusObj || formKartyaTipus;
    return kartyaTipus && kartyaTipus.ervenyessegVege && kartyaTipus.ervenyessegVege.name !== 'KEZI';
  }

  // Azért kell a paraméterből is átadni a kártyatípust, mert amikor az onChange megfut arra még nem kerül betöltésre a formKartyaTipus, null/előző érték lesz
  const isVegeTipusNapVege = (kartyaTipusObj) => {
    let kartyaTipus = kartyaTipusObj || formKartyaTipus;
    return kartyaTipus && kartyaTipus.ervenyessegVegeTipus && kartyaTipus.ervenyessegVegeTipus.name === 'NAPVEG';
  }

  const hasPartner = () => {
    return selectedPartner && selectedPartner.length > 0;
  }

  const hasSzemely = () => {
    return selectedSzemely && selectedSzemely.length > 0;
  }

  const renderMejgegyzes = () => {
    return <>
      <div className="row">
        <div className="col-md-12" style={ROW_STYLE}>
          <h5>Megjegyzés</h5>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={ROW_STYLE}>
          <RFField
            //style={{height: '10px'}}
            type="textarea"
            name={"formMegjegyzes"}
            value={formMegjegyzes}
            onChange={(e,v) => setFormMegjegyzes(v)}
          />
        </div>
      </div>
    </>;
  }

  const renderTulajdonosSelect = () => {
    return (
      <div className="row" style={ROW_STYLE}>
        <div className="col-md-12">
          {isTulajdonosPartner() ? 
          (
            <PartnerContent
              partnerData={dataPartner}
              selectedPartner={selectedPartner}
              onRowSelect={onRowSelectPartner}
              hasPartner={hasPartner()}
            />
          )
           : 
          (
            <SzemelyContent
              szemelyData={dataSzemely}
              selectedSzemely={selectedSzemely}
              onRowSelect={onRowSelectSzemely}
              hasSzemely={hasSzemely()}
            />
          )
          }
          {renderMejgegyzes()}
        </div>
      </div>
    );
  }
  
  const renderForm = () => {

    const groupActivate = formAzonosito && formAzonosito.length > 1;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-8" style={{paddingRight: '2px'}}>
            <h5>Kártya tulajdonságai</h5>
          </div>
        </div>
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-4" style={{paddingRight: '2px'}}>
            <SelectField
              label='Kártya típusa:'
              variant='async'
              name="formKartyaTipus"
              id="formKartyaTipus"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => {
                clearForm(v);
                setFormKartyaTipus(v);
                setFormFizetesimodkotelezo(v && v.fizetesimodkotelezo);
                handleSetFormKezdete(new Date(), v);
                if (isTulajdonosPartner(v)) {
                  loadPartnerData(v && v.partnercsoportId);
                } else {
                  loadSzemelyData();
                }
              }}
              loadOptions={_.debounce(loadKartyaTipusOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={formKartyaTipus}
              isDisabled={modositas || aktivalas}
              isClearable
              defaultOptions
              required
            />
          </div>
          {formKartyaTipus && (
            <React.Fragment>
              {(!!formKartyaTipus.azonositoGen || modositas) && (
                <div className="col-md-3" style={{paddingRight: '2px'}}>
                  <SelectField
                    variant='async'
                    label='Kártya azonosító/sorszám:'
                    name="formAzonosito"
                    id="formAzonosito"
                    placeholder="Kezdj el gépelni..."
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    onChange={v => {
                      handleUpdateClick(v);
                      setFormAzonosito(v);
                    }}
                    loadOptions={_.debounce(loadVasarloiKartyaOptions, 1000)}
                    getOptionLabel={option => option.azonosito}
                    getOptionValue={option => option.id}
                    value={formAzonosito}
                    isDisabled={modositas}
                    isClearable
                    isMulti={!modositas}
                    defaultOptions
                    required
                  />
                </div>
              )}
              {!formKartyaTipus.azonositoGen && !aktivalas && (
                <React.Fragment>
                {!modositas &&(
                  <div className="col-md-2">
                    <RFField
                      label="Mennyiség: "
                      name={"formMennyiseg"}
                      value={formMennyiseg}
                      //disabled={showCsere}
                      onChange={(e,v) => setFormMennyiseg(v)}
                    />
                  </div>
                )}
                <div className="col-md-2">
                  {modositas && <RFField
                    label="Csoport azonosító: "
                    name={"formCsoport"}
                    disabled
                    value={formCsoport}
                  />}
                </div>
              </React.Fragment>
              )}
              {formKartyaTipus.csere && !groupActivate && (
              <div className="col-md-2">
                <Button color="secondary" className="kartya-button" onClick={() => toggleShowCsere(!showCsere)} disabled={modositas && !aktivalas} style={{marginTop: '30px'}}>
                  <span className="h6" >
                    {"Csere   "}
                  </span> 
                  {showCsere ? 
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                  :
                    <i className="fa fa-square-o" aria-hidden="true"></i>
                  }
                </Button>
              </div>
              )}
              {formKartyaTipus.csere && showCsere && (
                <div className="col-md-3" style={{paddingRight: '2px'}}>
                  <SelectField
                    variant='async'
                    label='Cserélendő azonosító:'
                    name="formCserelt"
                    id="formCserelt"
                    placeholder="Kezdj el gépelni..."
                    noOptionsMessage={() => 'Nincs keresési eredmény'}
                    onChange={v => {
                      setFormCserelt(v);
                      if(v && v.aktiv){
                        if(isTulajdonosPartner()){
                          toggleShowTulajdonos(true);
                          onRowSelectPartner(v.aktiv.partnerTortenetId ? {id: v.aktiv.partnerTortenetId} : null, true);
                        }
                        setFormVege(v.aktiv.vege);
                      } 
                    }}
                    loadOptions={_.debounce(loadVasarloiKartyaCsereOptions, 1000)}
                    getOptionLabel={option => option.azonosito}
                    getOptionValue={option => option.id}
                    value={formCserelt}
                    isDisabled={modositas && !aktivalas}
                    isClearable
                    defaultOptions
                    required
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </div>
        {formKartyaTipus && (!modositas || (modositas && globals.hasRoleSpec(['KEDVEZMENY_VK_ADMIN']))) && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-6" style={{paddingRight: '2px'}}>
                <h5>Helyszín *</h5>
              </div>
              <div className="col-md-6" style={{paddingRight: '2px'}}>
                <h5>{'Fizetési mód' + (formFizetesimodkotelezo ? ' *' : '')}</h5>
              </div>
            </div>
            <div className="row" style={ROW_STYLE}>
              <div className="col-md-6" style={{paddingRight: '2px'}}>
                {/* <Label for="formHelyszin">Helyszín: </Label> */}
                <SelectField
                  variant='async'
                  name="formHelyszin"
                  id="formHelyszin"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => setFormHelyszin(v)}
                  loadOptions={_.debounce(loadHelyszinOptions, 1000)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={formHelyszin}
                  isClearable
                  defaultOptions
                  required
                />
              </div>
              <div className="col-md-6">
                <SelectField
                  variant='async'
                  name="formFizmod"
                  id="formFizmod"
                  placeholder="Kezdj el gépelni..."
                  noOptionsMessage={() => 'Nincs keresési eredmény'}
                  onChange={v => setFormFizmod(v)}
                  loadOptions={_.debounce(loadFizmodOptions, 1000)}
                  getOptionLabel={option => option.nev}
                  getOptionValue={option => option.id}
                  value={formFizmod}
                  isClearable
                  defaultOptions
                  required={formFizetesimodkotelezo}
                />
              </div>
            </div>
          </React.Fragment>
        )}
        {formKartyaTipus && (
          <React.Fragment>
            <div className="row">
              <div className="col-md-12" style={{paddingRight: '2px'}}>
                <h5>Érvényesség</h5>
              </div>
            </div>
            <div className="row" style={ROW_STYLE}>
              <div className="col-md-3">
                <DatetimePicker
                    label={'Érvényesség kezdete: *'}
                    id={"formKezdete"}
                    name={"formKezdete"}
                    value={formKezdete && new Date(formKezdete)}
                    onChange={(e) => handleSetFormKezdete(e)}
                    onSelect={() => { selected = true }}
                    disabled={isDisabledKezdete()}
                    containerClassName="organw-date-time"
                    time={true}
                    // format="YYYY-MM-DD HH:mm:ss"
                    messages={{ dateButton: "dátum" , timeButton: "idő"}}
                    timePrecision="seconds"
                    required
                  />
              </div>
              {isVisibleVege() && (
                  <div className="col-md-3">
                    {/* <CSSTransition 
                      in={formVege}
                      appear={true}
                      timeout={200}
                      classNames="kartya-input"
                      unmountOnExit
                    > */}
                      <DatetimePicker
                        label={'Érvényesség vége:'}
                        key={"formVege"}
                        id={"formVege"}
                        name={"formVege"}
                        value={formVege && new Date(formVege) }
                        onChange={(e) => handleSetFormVege(e)}
                        onSelect={() => { selected = true }}
                        disabled={isDisabledVege()}
                        containerClassName={ "organw-date-time"}
                        time={true}
                        // format="YYYY-MM-DD HH:mm:ss"
                        messages={{ dateButton: "dátum" , timeButton: "idő"}}
                        timePrecision="seconds"
                      />
                    {/* </CSSTransition> */}
                </div>
              )}
              {!aktivalas && (!modositas ||  (modositas && globals.hasRoleSpec(['KEDVEZMENY_VK_ADMIN']))) && (
                <div className="col-md-3">
                  <DatetimePicker
                      label={'Érvénytelenítés dátuma: '}
                      id={"formErvenytelenites"}
                      name={"formErvenytelenites"}
                      value={formErvenytelenites && new Date(formErvenytelenites)}
                      onChange={(e, v) => handleSetFormErvenytelenites(e, v)}
                      onSelect={() => { selected = true }}
                      containerClassName="organw-date-time"
                      time={true}
                      // format="YYYY-MM-DD HH:mm:ss"
                      timePrecision="seconds"
                      messages={{ dateButton: "dátum" , timeButton: "idő"}}
                    />
                </div>
              )}
            </div>
            {isVisibleAnyTulajdonos() && (
              <React.Fragment>
                <div className="row" style={ROW_STYLE}>
                  <div className="col-md-4">
                      <span className="h5" style={{color: '#666'}} onClick={() => toggleShowTulajdonos(!showTulajdonos)}>
                        {"Tulajdonos"}
                        <i className={'fa fa-angle-' + (showTulajdonos ? 'up' : 'down')} aria-hidden="true" style={{ paddingLeft: '5px'}} />
                      </span>
                  </div>
                  {showTulajdonos && isTulajdonosPartner() && (
                    <div className="col-md-2">
                      <Button disabled={!formHelyszin} type="button" color="primary" onClick={() => toggleShowTulajdonosForm(true)}>
                        {"Új partner"}
                        <i className="fa fa-plus" aria-hidden="true" style={{ paddingLeft: '10px'}}></i>
                      </Button>
                    </div>
                  )}
                </div>
                {showTulajdonos && renderTulajdonosSelect()}
              </React.Fragment>
            )}
            {!isVisibleAnyTulajdonos() && renderMejgegyzes()}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  const renderModals = () => {
    return(
      <React.Fragment>
        {showTulajdonosForm && (
          <PartnerForm 
            aktivalas={aktivalas}
            modositas={modositas}
            formKartyaTipus={formKartyaTipus}
            formHelyszin={formHelyszin}
            onRowSelect={onRowSelectPartner}
            setPartnerResponse={setPartnerResponse}
            toggleShowTulajdonosForm={handleToggleShowTulajdonosForm}
            telefonTipusOptions={telefonTipusOptions}
            orszagHivoOptions={orszagHivoOptions}
          >
          </PartnerForm>
        )}
        {(showTulajdonosGdprForm && partnerResponse) && (
          <PartnerHozzajarulasForm
            globals={globals}
            partnerId={partnerResponse.pId}
            hozzajarulasData={partnerResponse.hozzajarulasok}
            hozzajarulasModal={showTulajdonosGdprForm}
            toggleHozzajarulasModal={toggleShowTulajdonosGdprForm}
            setPartnerResponse={setPartnerResponse}
            toggleShowTulajdonosForm={handleToggleShowTulajdonosForm}
          >
          </PartnerHozzajarulasForm>
        )}
      </React.Fragment>
    );
  }

  
  return (
    <Modal isOpen toggle={() => toggleFormModal()} backdrop="static" size="lg">
      <RFForm
        modal
        onSubmit={saveVasarloiKartya}
        title={aktivalas ? 'Vásárlói kártya aktiválása': !modositas ? 'Vásárlói kártya rögzítése': 'Vásárlói kártya módosítása'}
        footer={
          <>
            <ProgressButton
            className="btn-cursor-pointer"
            color="primary"
            loading={loadingSaveButton}
          >
            {'Mentés'}
          </ProgressButton>
          <Button type="button" color="secondary" onClick={() => toggleFormModal()}>
            Mégsem
          </Button>
          </>
        }
      >
        {{
          LOAD: (<Loader />),
          NETW: (
            <NetworkEmptyState
              hasImage
              submitClick={() => getVasarloiKartya(id)}
            />),
          DATA: 
          <div className="row">
            <div className="col-md-12">
              {renderForm()}
              {renderModals()}
            </div>
          </div>
        }[formStatus]}
      </RFForm>
    </Modal>
  );
}

export default VasarloiKartyaForm;